// library imports
import { Skeleton, Flex, Divider, Tabs, Select, Row, Col } from "antd";
// component import
import BESSTable from "./BESSTable";
import { LabelValueUnitDisplayRow } from "../../common/WordDisplay";

export default function BESSContent({
  devicePhaseNumberList,
  deviceList,
  systemData,
  tableData,
  handleDeviceChange,
  bessSystemLoading,
  bessDeviceLoading,
  deviceSelectionLoading,
  selectedDeviceID,
  systemLastUpdate,
  deviceLastUpdate,
  setPhaseNumberSelected,
}) {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          align: "center",
          marginBottom: "12px",
        }}
      >
        <h2 style={{ margin: "0px" }}>BESS</h2>
        <span>Last Update: {systemLastUpdate}</span>
      </div>
      {bessSystemLoading ? (
        <Skeleton active style={{ margin: "5px" }} />
      ) : (
        <Row gutter={[24, 24]}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={8}>
            <LabelValueUnitDisplayRow
              label={"Maximum Demand Reduced"}
              value={
                systemData?.maximumDemandReduced !== undefined
                  ? systemData.maximumDemandReduced
                  : "-"
              }
              unit={"kW"}
            />
            <LabelValueUnitDisplayRow
              label={"Status"}
              value={systemData?.status !== undefined ? systemData.status : "-"}
              unit={""}
            />
            {/* <LabelValueUnitDisplayRow
              label={"Mode"}
              value={systemData?.mode !== undefined ? systemData.mode : "-"}
              unit={""}
            />
            <LabelValueUnitDisplayRow
              label={"Grid Mode"}
              value={
                systemData?.gridMode !== undefined ? systemData.gridMode : "-"
              }
              unit={""}
            /> */}
          </Col>

          <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={8}>
            <LabelValueUnitDisplayRow
              label={"Total Charging Power"}
              value={
                systemData?.totalChargingPower !== undefined
                  ? systemData.totalChargingPower
                  : "-"
              }
              unit={"kW"}
            />
            <LabelValueUnitDisplayRow
              label={"Total Discharging Power"}
              value={
                systemData?.totalDischargingPower !== undefined
                  ? systemData.totalDischargingPower
                  : "-"
              }
              unit={"kW"}
            />
            <LabelValueUnitDisplayRow
              label={"Dischargeable Energy"}
              value={
                systemData?.dischargeableEnergy !== undefined
                  ? systemData.dischargeableEnergy
                  : "-"
              }
              unit={"kWh"}
            />
            <LabelValueUnitDisplayRow
              label={"Chargeable Energy"}
              value={
                systemData?.chargeableEnergy !== undefined
                  ? systemData.chargeableEnergy
                  : "-"
              }
              unit={"kWh"}
            />
          </Col>
        </Row>
      )}

      <div>
        <Divider />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            align: "center",
          }}
        >
          <h2 style={{ margin: "0px" }}>BESS Main Parameters</h2>
          <span>Last Update: {deviceLastUpdate}</span>
        </div>
        {/* <Tabs
          items={devicePhaseNumberList}
          onChange={(key) => setPhaseNumberSelected(key)}
        /> */}
        <Flex justify="space-between" align="center" className="mt-3 mb-3">
          {deviceList.length > 0 && selectedDeviceID ? (
            <Select
              loading={deviceSelectionLoading}
              onChange={(value) => handleDeviceChange(value)}
              value={selectedDeviceID}
              options={deviceList}
              style={{ width: "100%", marginRight: "8px" }}
            />
          ) : (
            <></>
          )}
        </Flex>
        {bessDeviceLoading ? (
          <Skeleton active style={{ margin: "5px" }} />
        ) : (
          <BESSTable data={tableData} />
        )}
      </div>
    </div>
  );
}
